import { z } from "zod";
import { LookupListPage } from "@/pages/admin/lookups/LookupListPage";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

interface Row { bomItemTypeCode: string; name: string; deleted: boolean; }
const schema = z.object({
  bomItemTypeCode: z.string().min(1).max(20),
  name: z.string().min(1).max(100),
  deleted: z.boolean(),
});
type Form = z.infer<typeof schema>;

export function BomItemTypesPage() {
  return <LookupListPage<Row, Form>
    title="Item types"
    apiPath="/api/lookups/bom-item-types"
    schema={schema}
    rowKey={(r) => r.bomItemTypeCode}
    columns={[
      { id: "code", header: "Code", accessor: (r) => r.bomItemTypeCode },
      { id: "name", header: "Name", accessor: (r) => r.name },
    ]}
    toFormValues={(r) => ({ bomItemTypeCode: r.bomItemTypeCode, name: r.name, deleted: r.deleted })}
    toApiBody={(f) => f}
    blankFormValues={{ bomItemTypeCode: "", name: "", deleted: false }}
    fields={(f) => (
      <div className="space-y-3">
        <div><Label htmlFor="c">Code</Label><Input id="c" {...f.register("bomItemTypeCode")} /></div>
        <div><Label htmlFor="n">Name</Label><Input id="n" {...f.register("name")} /></div>
        <Button type="submit">Save</Button>
      </div>
    )}
  />;
}
